var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsubscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 392,
    height: 391,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.421 63.466s46.315 7.474 66.163 16.728c10.866 5.065-2.8 54.81-2.8 54.81L259.869 102.26l24.281-44.102c14.171.802 27.589 1.954 36.271 5.308z",
    fill: "#0080A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.48 88.096c2.833 5.09-14.619 83.685-33.245 129.017-2.796 6.807-11.986 8.573-19.164 6.671l-40.835-10.825 1.68-150.137 28.504 4.018s59.955 15.68 63.06 21.256z",
    fill: "#00AEC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.4 129.072l32.137 9.446-8.98 30.657-32.136-9.758c-.699-.232 8.979-30.345 8.979-30.345z",
    fill: "#FFFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.475 169.635l-1.02 3.105-40.451-13.396 1.02-3.105 40.451 13.396z",
    fill: "#0080A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.947 143.715l-.474 1.903-24.446-6.148.475-1.903 24.445 6.148zM354.2 149.778l-.475 1.903-24.444-6.148.475-1.903 24.444 6.148zM352.453 155.841l-.475 1.903-24.445-6.148.474-1.903 24.446 6.148zM350.699 161.989l-.475 1.903-24.445-6.148.474-1.903 24.446 6.148z",
    fill: "#B3E0D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.043 217.001l2.798-.793-1.897-2.726s11.322 5.493 16.886 8.077l-.785 1.682c-5.469-2.54-17.002-6.24-17.002-6.24z",
    fill: "#D7456E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.832 213.179c-1.26-3.286-.897-6.226.97-7.864 2.05-1.798 5.17-1.323 7.2-.12 2.858 1.69 4.896 4.926 5.594 8.876.606 3.436.208 6.875-.177 10.2l-1.86-.224c.37-3.193.753-6.496.193-9.667-.603-3.412-2.315-6.179-4.7-7.59-1.512-.896-3.717-1.21-5.005-.079-1.487 1.305-1.216 3.86-.466 5.816 1.701 4.439 5.385 8.101 9.852 9.796l-.658 1.735c-4.963-1.882-9.053-5.95-10.943-10.879z",
    fill: "#D7456E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.14 225.038a37.491 37.491 0 0010.949-8.039c.83-.88 1.659-1.847 2.106-2.958.443-1.099.426-2.241-.045-3.055-.797-1.378-2.77-1.758-4.371-1.523-2.79.41-5.464 2.282-7.338 5.137-1.813 2.76-2.717 6.093-3.363 8.988l-1.828-.412c.682-3.058 1.646-6.59 3.621-9.597 2.164-3.297 5.307-5.467 8.623-5.954 2.069-.304 4.954.153 6.278 2.443.754 1.304.815 3.051.162 4.672-.562 1.394-1.522 2.522-2.475 3.534a39.375 39.375 0 01-11.489 8.434l-.83-1.67z",
    fill: "#D7456E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.432 255.478l38.126-1.613 9.95 10.244s-25.495 1.373-48.076-8.631z",
    fill: "#7DB1A1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.95 222.692c3.027-.071 35.016-2.466 35.812.297.797 2.762-1.728 35.29-3.857 36.471-2.13 1.181-33.781.584-34.024-5.182-.243-5.766-.958-31.515 2.069-31.586z",
    fill: "#523B5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.807 226.829c-.158 2.941-6.572 36.705-9.298 37.279-2.725.575-18.62-2.302-18.62-2.302l3.856-36.471s24.221-1.448 24.062 1.494z",
    fill: "#3F2C48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.56 230.332l39.793-1.754-3.912-53.957-41.68 12.374 5.799 43.337z",
    fill: "#B3E0D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.477 178.521l-1.173 48.912-27.502 1.213-2.362-54.025 31.037 3.9z",
    fill: "#7DB1A1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.802 228.646l.863-.038 27.664-43.913.05-2.048-.313-.198L63.749 227.4l.054 1.246z",
    fill: "#B3E0D0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.503 227.469l.802-.036.033-1.344-29.189-49.582-.61.363.066 1.511 28.898 49.088z",
    fill: "#B3E0D0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.56 230.332l-.142-1.061 14.637-21.749-20.142-19.395-.151-1.132.782-.232 20.317 19.562 20.092-29.854.655.444.073 1.015-19.782 29.395 21.317 20.526-.817.857-.326.014-20.98-20.2-14.65 21.771-.883.039z",
    fill: "#FFFFFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.537 176.87l-.368-8.411-42.558 13.915.313 7.142 42.613-12.646z",
    fill: "#7DB1A1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.37 176.058l.295 6.771-31.127-5.959-.368-8.411 31.2 7.599z",
    fill: "#B3E0D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.652 304.653l17.718 22.303 8.258-38.167-13.704-25.1-12.272 40.964zM276.172 278.79l-3.263-19.759c-.941-5.703-5.854-9.885-11.612-9.885H144.613l10.693 29.644c40.185 8.831 80.48 8.252 120.866 0z",
    fill: "#3A3B39"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.952 278.79c2.438 0 4.385 2.039 4.281 4.485l-1.315 31.283-12.744-35.768h9.778z",
    fill: "#FB9300"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.53 336.447l-29.395 13.88c-31.585 2.338-61.459 3.689-82.587 0l-24.812-71.537h116.436c6.073 13.335 13.152 34.971 20.358 57.657z",
    fill: "#F57100"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.671 311.931c-18.34 6.289-27.361 28.578-20.149 49.784 7.212 21.205 27.927 33.298 46.266 27.009 18.34-6.289 27.361-28.578 20.149-49.784-7.213-21.205-27.926-33.297-46.266-27.009z",
    fill: "#3A3B39"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.736 278.79l2.481 4.626h118.031l-4.076-4.626H159.736z",
    fill: "#FB9300"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.629 324.902c-9.877 2.723-15.128 15.012-11.729 27.45 3.399 12.438 14.163 20.314 24.04 17.591 9.878-2.722 15.13-15.011 11.731-27.449-3.401-12.437-14.163-20.314-24.042-17.592z",
    fill: "#B3E0D0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.618 311.931c-18.34 6.289-27.36 28.578-20.149 49.784 7.212 21.205 27.926 33.298 46.267 27.009 18.339-6.289 27.36-28.578 20.148-49.784-7.213-21.205-27.926-33.297-46.266-27.009z",
    fill: "#3A3B39"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.577 324.902c-9.878 2.723-15.13 15.012-11.73 27.45 3.4 12.438 14.163 20.314 24.04 17.591 9.879-2.722 15.13-15.011 11.73-27.449-3.4-12.437-14.162-20.314-24.04-17.592z",
    fill: "#B3E0D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.285 183.532c1.03-3.202-1.348-6.482-4.699-6.482h-16.842c-6.367 0-12.09 3.627-14.892 9.204h34.255a4.937 4.937 0 002.178-2.722z",
    fill: "#3A3B39"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.209 350.328s-.946-58.013-45.961-58.013-42.888 58.013-42.888 58.013h88.849z",
    fill: "#FB9300"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.53 223.537a3.285 3.285 0 013.278-3.292 3.285 3.285 0 013.278 3.292 3.285 3.285 0 01-3.278 3.292 3.285 3.285 0 01-3.279-3.292zm-5.608 30.45a2.732 2.732 0 01-2.725 2.737h-.71a2.732 2.732 0 01-2.725-2.737v-31.54a2.731 2.731 0 012.725-2.737h.71a2.731 2.731 0 012.725 2.737v31.54zm-13.984 0a2.732 2.732 0 01-2.726 2.737h-.709a2.732 2.732 0 01-2.725-2.737v-31.54a2.731 2.731 0 012.725-2.737h.709a2.731 2.731 0 012.726 2.737v31.54zm-13.983 0a2.732 2.732 0 01-2.726 2.737h-.709a2.732 2.732 0 01-2.725-2.737v-31.54a2.731 2.731 0 012.725-2.737h.71a2.731 2.731 0 012.725 2.737v31.54zm-13.983 0a2.732 2.732 0 01-2.725 2.737h-.71a2.732 2.732 0 01-2.724-2.737v-31.54a2.731 2.731 0 012.725-2.737h.709a2.731 2.731 0 012.725 2.737v31.54zm-15.941-32.713l5.309 42.415 56.486 3.483 19.838-54.458H26.551c-4.561 0-8.088 4.016-7.52 8.56z",
    fill: "#F57100"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.21 350.328s-.059-3.554-.828-8.898h-87.664c-.486 5.344-.357 8.898-.357 8.898 31.197 2.877 61.004 3.223 88.849 0z",
    fill: "#B3E0D0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.812 350.328c-5.99 0-11.413-3.562-13.813-9.072l-28.727-65.963a42.857 42.857 0 01-2.176-27.931l17.997-61.108h-15.242c-.311.619-15.94 49.376-22.29 69.196a11.832 11.832 0 01-11.263 8.239h-45.96s3.544 10.954 16.304 10.892c12.76-.061 38.99 5.237 55.294 35.687 16.305 30.45 19.141 46.822 43.243 46.822h165.264v-6.762H145.812z",
    fill: "#FB9300"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.04 289.468c37.676 6.175 39.782 57.419 63.37 69.52l-30.04-1.898c-10.485 0-18.356-5.608-25.06-13.703l-11.578-14.058c-5.481-6.619-14.82-10.549-23.393-10.549L0 321.321s13.365-38.029 51.04-31.853z",
    fill: "#FB9300"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.126 341.546c-2.578.71-3.948 3.917-3.061 7.164.887 3.245 3.696 5.3 6.274 4.59 2.578-.711 3.948-3.918 3.06-7.163-.886-3.246-3.695-5.302-6.273-4.591z",
    fill: "#7DB1A1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.514 350.802a35.223 35.223 0 01-27.128-12.776l-11.96-14.443a28.802 28.802 0 00-22.184-10.448H3.986C1.23 317.828 0 321.321 0 321.321h23.803a28.805 28.805 0 0122.183 10.447l11.96 14.443a35.222 35.222 0 0027.128 12.777h29.336c-3.675-1.885-6.827-4.72-9.674-8.186H87.514z",
    fill: "#F57100"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.826 313.879l-5.738-17.45c-.154-.467.181-.949.748-1.075.567-.127 1.151.149 1.305.616l5.737 17.45c.154.467-.181.948-.748 1.075a1.269 1.269 0 01-.279.031c-.468 0-.897-.257-1.025-.647zM191.374 313.879l-5.737-17.45c-.154-.467.181-.949.747-1.075.566-.127 1.152.149 1.305.616l5.738 17.45c.154.467-.181.948-.748 1.075a1.269 1.269 0 01-.279.031c-.468 0-.897-.257-1.026-.647zM198.926 313.879l-5.738-17.45c-.154-.467.181-.949.747-1.075.568-.127 1.152.149 1.305.616l5.738 17.45c.153.467-.181.948-.748 1.075a1.276 1.276 0 01-.279.031c-.468 0-.898-.257-1.025-.647zM206.474 313.878l-5.737-17.449c-.154-.467.181-.949.747-1.075.567-.127 1.151.149 1.305.616l5.737 17.449c.154.468-.181.949-.748 1.076a1.267 1.267 0 01-.278.031c-.469 0-.898-.257-1.026-.648z",
    fill: "#FB9300"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.235 373.127c7.446-6.914 7.295-20.372-.306-27.115-7.601-6.743-20.92-5.236-26.836 3.037-4.112 5.752-4.452 12.991-3.569 20.209-2.876-5.104-8.721-8.706-14.56-7.706-8.994 1.539-14.403 13.379-9.7 21.229-12.653-1.339-36.625 7.606-36.625 7.606h101.145c3.418-2.972 4.215-8.467 2.046-12.45-2.169-3.983-7.259-6.095-11.595-4.81z",
    fill: "#B3E0D0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.246 350.773h-25.875l12.937-9.12-4.784-9.12 11.696 4.012 6.026 14.228z",
    fill: "#3A3B39"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.967 350.772h-23.748l11.874-7.661-6.558-10.579 12.525 1.581 5.907 16.659z",
    fill: "#3A3B39"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.659 265.859c15.241 40.692 33.318 70.588 33.318 70.588h15.241l-15.241-53.742-15.064-69.991s-33.495 12.453-18.254 53.145z",
    fill: "#008B44"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.259 226.828c-10.398 27.998 23.629 72.605 23.629 72.605l25.991 37.014 14.18-2.373-27.41-82.095 104.851.416a30.42 30.42 0 0023.908-11.479l4.04-5.072-56.712-42.709-10.397 6.169s-91.684-.474-102.08 27.524z",
    fill: "#00A650"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.276 249.146s6.198-2.581 14.171-13.302l-56.711-40.336-6.617 2.847 49.157 50.791zM147.924 238.217l11.815 13.761h-7.089l-4.726-13.761z",
    fill: "#008B44"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.564 24.316l1.77 2.314 5.914 9.341 4.722 27.496 20.203-14.237-12.05-36.48-9.394-.712-11.165 12.278z",
    fill: "#F9B6A8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.413 30.188l-7.355-2.58-5.593 19.023 12.948-16.443z",
    fill: "#3A3B39"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.526 49.585c5.494 10.322 20.026 5.695 23.394-4.092 3.367-9.787 6.203-16.906 6.203-16.906l-3.368-1.957s-10.102 9.965-16.659 4.093c0 0-15.064 8.541-9.57 18.862z",
    fill: "#FB9300"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.248 39.62s-15.863-5.73-6.914-12.99c0 0 5.694 5.73 6.914 12.99z",
    fill: "#F57100"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.248 10.614s8.153-15.72 19.849-8.898c11.697 6.82 3.851 24.365 1.772 27.049-2.481 3.203-8.861 3.381-12.582 0-3.722-3.382 1.595-11.39 1.595-11.39l-10.634-6.761z",
    fill: "#FB9300"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.137 21.024a3.286 3.286 0 00-3.28 3.292 3.286 3.286 0 003.28 3.292 3.285 3.285 0 003.278-3.292 3.285 3.285 0 00-3.278-3.292z",
    fill: "#CC4900"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.729 18.8c-.685 0-1.241.557-1.241 1.245 0 .688.556 1.246 1.241 1.246s1.24-.558 1.24-1.246-.555-1.245-1.24-1.245zM257.224 18.591a2.028 2.028 0 00-.926-1.63 2.011 2.011 0 00-1.865-.118.488.488 0 01-.648-.24.492.492 0 01.24-.652 2.971 2.971 0 012.789.178 2.997 2.997 0 011.387 2.437.489.489 0 01-.476.503h-.013a.49.49 0 01-.488-.478z",
    fill: "#3A3B39"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.419 63.466l-11.815-32.24c-18.904 9.403-52.635 32.24-52.635 32.24-29.951 20.287-37.63 108.315-37.63 108.315l-71.363-3.322-2.363 15.66s42.534 15.185 77.979 19.456c3.316.4 6.501-.099 9.548-1.33l52.363 43.564c23.629-46.03 28.827-115.788 28.354-151.379-.356-26.88-14.191-33.458-20.942-35.068l28.504 4.104z",
    fill: "#523B5D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.783 180.951l5.714-9.17 41.998 26.301-3.103 11.681-44.609-28.812z",
    fill: "#3F2C48"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.73 142.359s-7.411 51.991-30.263 63.484l-4.324-3.598s20.594-1.992 34.587-59.886zM228.735 171.781l-9.853-5.212-.544 5.212h10.397zM283.084 52.67l30.249-8.542-1.652-4.508-28.597 13.05z",
    fill: "#3F2C48"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.647 168.458l-7.797 10.678 8.152 1.816 6.912-6.247 13.659 3.063 1.405-9.31h-22.331z",
    fill: "#F9B6A8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.999 60.814c-10.034-1.937-23.982-3.078-38.142-2.594 15.252 1.81 30.114 3.907 40.588 9.268l-2.446-6.674z",
    fill: "#3F2C48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unsubscribe_svg__clip0_2658_58005)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 57.33c0 4.401-1.743 8.401-4.575 11.338-.131.15-.272.291-.423.422a16.33 16.33 0 01-23.093-23.092c.131-.152.273-.295.423-.427A16.33 16.33 0 01118 57.33zm-16.331-9.794a9.795 9.795 0 018.845 14.017L97.443 48.49a9.76 9.76 0 014.226-.954zm-8.845 5.577l13.063 13.063a9.793 9.793 0 01-13.881-7.183 9.796 9.796 0 01.818-5.88zm8.845 25.999c.465 0 .93-.015 1.395-.044v3.652c0 1.02.435 2.03 1.259 2.797.954.889 1.704 1.233 2.784 1.233a2.18 2.18 0 012.179 2.178 2.18 2.18 0 01-2.179 2.18H59.179a2.179 2.179 0 110-4.358c1.08 0 1.83-.344 2.788-1.233a3.834 3.834 0 001.255-2.797V66.27c0-5.02 2.135-9.803 5.887-13.298a20.479 20.479 0 0113.093-5.416 21.778 21.778 0 0019.467 31.555zm-26.151 19.62a3.267 3.267 0 013.268-3.268H87.5a3.268 3.268 0 110 6.536h-8.714a3.267 3.267 0 01-3.268-3.268z",
    fill: "#E73A5E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unsubscribe_svg__clip1_2658_58005)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.506 220.494a6.512 6.512 0 01-.062 4.887 1.65 1.65 0 01-.096.219 6.532 6.532 0 01-12.009-.302 6.528 6.528 0 01.058-4.956c.027-.076.059-.149.096-.22a6.527 6.527 0 019.697-2.594 6.533 6.533 0 012.316 2.966zm-7.504-1.283a3.917 3.917 0 015.326 3.941l-6.763-2.973a3.9 3.9 0 011.437-.968zm-2.488 3.36l6.76 2.974a3.911 3.911 0 01-4.432.905 3.92 3.92 0 01-2.328-3.879zm7.063 8.405c.173-.067.344-.14.513-.218l.529 1.36c.148.38.457.694.875.86.484.193.813.213 1.216.056a.873.873 0 011.113 1.163.872.872 0 01-.482.461l-17.858 6.945a.873.873 0 01-1.113-1.163.875.875 0 01.482-.461c.403-.156.632-.393.86-.863a1.54 1.54 0 00.063-1.224l-2.384-6.129c-.727-1.87-.625-3.962.267-5.808a8.185 8.185 0 014.093-3.915 8.714 8.714 0 003.418 7.769 8.71 8.71 0 008.408 1.167zm-6.901 11.1a1.308 1.308 0 01.744-1.691l3.247-1.263a1.305 1.305 0 11.947 2.435l-3.247 1.263a1.303 1.303 0 01-1.691-.744z",
    fill: "#E73A5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unsubscribe_svg__clip0_2658_58005"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(57 41)",
    d: "M0 0h61v61H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "unsubscribe_svg__clip1_2658_58005"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-21.251 770.21 -822.29)",
    d: "M0 0h24.387v24.387H0z"
  })))));
}
export default SvgUnsubscribe;